import axios from "axios";
import { useEffect, useState } from "react";
import MainLayout from "src/components/MainLayout";
import { AppConfig } from "src/config/AppConfig";
import "./WorkerCategories.css";
import Swal from "sweetalert2";
import { Button, Col, Row, Form } from "react-bootstrap";
import { Formik } from 'formik';
import * as yup from 'yup';
import Modal from 'react-bootstrap/Modal';
import { ICategory } from "src/helper/interfaces";
import Cookies from "js-cookie";
import { useAppDispatch, useAppSelector } from "src/hooks/redux/hooks";
import { startLoading, stopLoading } from "src/store/loading/loadingSlice";
import LoadingGif from "src/components/layout/Loader";

interface InitialValuesType {
   name: string;
   image: string | null;
}

export const getAllCategories = async (token: string) => {
   return await axios.get(`${AppConfig.DEV_SERVER}/categories`, {
      headers: {
         "x-access-token": token
      }
   })

};

const CategoryPage = () => {
   const [categories, setCategories] = useState<ICategory[]>([]);
   const [editMode, setEditMode] = useState(false);
   const [modalShow, setModalShow] = useState(false);
   const Token = Cookies.get("token");
   const [selectedCategory, setSelectedCategory] = useState<any | null>(null);
   const dispatch = useAppDispatch();
   const loading = useAppSelector(state => state?.loading?.value);
   const initialValues: InitialValuesType = {
      name: "",
      image: null,
   };

   const [inputs, setInputs] = useState(initialValues);
   const validationSchema = yup.object().shape({
      name: yup.string()
         .required('Please Fill this field (Name)')
         .test('no-numbers', 'Name should not contain numbers', function (value) {
            return /^[A-Za-z\s]+$/.test(value);
         }),
      image: yup.mixed().required('Please upload a file'),
   });

   useEffect(() => {
      if (Token) {
         dispatch(startLoading());
         getAllCategories(Token).then((res) => {
            // console.log(res?.data)
            if (res?.data?.status_code === 200) {
               setCategories(res?.data?.data)
            } else {
               Swal.fire({
                  icon: "error",
                  title: "Oops...",
                  text: `${res?.data?.msg}`,
                  footer: '<a href="#">Why do I have this issue?</a>'
               });
            }
         })
            .catch((err: any) => {
               console.log(err)
            }).finally(() => {
               dispatch(stopLoading());
            })
      }

   }, [Token]);


   // const onCreate = () => {
   //    setEditMode(false);
   //    setModalShow(true);
   //    setInputs({
   //       name: "",
   //       image: null
   //    })
   // }
   const onHide = () => {
      setModalShow(false);
      setEditMode(false);
      // setInputs(initialValues);
   }
   // const onUpdate = (id: string) => {
   //    const categoriesToEdit = categories.find((category) => category._id === id);
   //    setSelectedCategory(categoriesToEdit);
    
   //    // Populate the form fields with the existing data
   //    setInputs({
   //       ...inputs,
   //       name: categoriesToEdit?.category_name || "",
   //       image: categoriesToEdit?.category_icon ? categoriesToEdit?.category_icon : null
   //    });
   //    setEditMode(true);
   //    setModalShow(true);
   // };

   // const handleDeleteConfirmed = (id: string) => {
   //    // console.log(id);
   //    if (Token === undefined) {
   //       console.error("Token is undefined");
   //       return;
   //    }
   //    // Dispatch the delete action here
   //    Swal.fire({
   //       title: 'Are you sure?',
   //       text: "You won't be able to revert this!",
   //       icon: 'warning',
   //       showCancelButton: true,
   //       confirmButtonColor: '#3085d6',
   //       cancelButtonColor: '#d33',
   //       confirmButtonText: 'Yes, delete it!'
   //    }).then(async (response) => {
   //       if (response.isConfirmed) {

   //          await axios({
   //             url: `${AppConfig.DEV_SERVER}/delete-category/${id}`,
   //             method: "DELETE",
   //             headers: {
   //                'content-type': 'multipart/form-data',
   //                "x-access-token": Token,
   //             }
   //          }).then((res) => {
   //             // console.log(res)
   //             Swal.fire(
   //                'Deleted!',
   //                `${res?.data?.msg}`,
   //                'success'
   //             );
   //             getAllCategories(Token).then((res) => {
   //                // console.log(res?.data)
   //                if (res?.data?.status_code === 200) {
   //                   setCategories(res?.data?.data)
   //                }
   //             })
   //                .catch((err: any) => {
   //                   console.log(err)
   //                })
   //          }).catch((err) => {
   //             console.log(err)
   //          })  // Clear the selectedFoodItem state after updating
   //          setModalShow(false);
   //       }
   //    }
   //    )
   // };


   const handleFormSubmit = async (formInput: any, resetForm: () => void) => {
      const formData = new FormData();

      // console.log(formInput);

      formData.append('category_name', formInput.name);

      if (formInput.image !== "" && formInput.image !== undefined) {
         formData.append('category_icon', formInput.image);
      }

      // console.log(formInput);
      if (!Token) return;
      dispatch(startLoading());
      if (!editMode) {
         // Add new food item
         await axios({
            url: `${AppConfig.DEV_SERVER}/categories`,
            method: "POST",
            data: formData,
            headers: {
               'content-type': 'multipart/form-data',
               "x-access-token": Token,
            }
         }).then(async () => {
            getAllCategories(Token).then((res) => {
               // console.log(res?.data)
               if (res?.data?.status_code === 200) {
                  setCategories(res?.data?.data)
               }
            })
               .catch((err: any) => {
                  console.log(err)
               });
            setModalShow(false);
            Swal.fire({
               position: "center",
               icon: "success",
               title: `Added new category, ${formInput.name}.`,
               showConfirmButton: false,
               timer: 1500
            });
            resetForm();
         }).catch(err => console.log(err)).finally(() => dispatch(stopLoading()))


      } else {
         if (selectedCategory != null) {
            if (selectedCategory?._id) {
               formData.append("category_id", selectedCategory?._id)
               // console.log(selectedCategory);
               await axios({
                  url: `${AppConfig.DEV_SERVER}/category`,
                  method: "PUT",
                  headers: {
                     'content-type': 'multipart/form-data',
                     "x-access-token": Token,
                  },
                  data: formData,
               }).then(async () => {
                  getAllCategories(Token).then((res) => {
                     // console.log(res?.data)
                     if (res?.data?.status_code === 200) {
                        setCategories(res?.data?.data)
                     }
                  })
                     .catch((err: any) => {
                        console.log(err)
                     });
                  setModalShow(false);
                  Swal.fire({
                     position: "center",
                     icon: "success",
                     title: `Updated category, ${formInput.name}.`,
                     showConfirmButton: false,
                     timer: 1500
                  });
                  resetForm();
               }).catch(err => console.log(err)).finally(() => dispatch(stopLoading()))

            }
         } else {
            console.error("Selected food item or its ID is undefined.");
         }
      }
   };

   return (
      <MainLayout>
         <Formik
            validationSchema={validationSchema}
            onSubmit={(values, { resetForm }) => {
               handleFormSubmit(values, resetForm)
            }}
            enableReinitialize={true}
            validateOnChange={false}
            validateOnBlur={false}
            initialValues={inputs}
         >
            {({ handleSubmit, handleChange, setFieldValue, values, touched, errors }) => (
               <Modal show={modalShow} onHide={() => onHide()} size="lg" className="rounded-9 category-modal">
                  <Form noValidate onSubmit={handleSubmit}>
                     <Modal.Header closeButton>
                        <Modal.Title as="h5">{editMode ? 'Update Category' : 'Add Category'}</Modal.Title>
                     </Modal.Header>
                     <Modal.Body>
                        <Row className="fieldset-row" >
                           <Col md={12} className="mb-2">
                              <Form.Control name="image" type="file" onChange={(event: any) => {
                                 const file = event.currentTarget.files[0];
                                 // console.log(file);
                                 setFieldValue("image", file);
                              }} isValid={touched.image && !errors.image} isInvalid={!!errors.image} />
                              <Form.Control.Feedback type="invalid">
                                 {errors.image}
                              </Form.Control.Feedback>
                           </Col>
                           <Col md={12} className="mb-2">
                              <Form.Label htmlFor="name">Category Name</Form.Label>
                              <Form.Control id="name" type='text' onChange={handleChange} isValid={touched.name && !errors.name} value={values.name} isInvalid={!!errors.name} />
                              <Form.Control.Feedback type="invalid">
                                 {errors.name}
                              </Form.Control.Feedback>
                           </Col>

                        </Row>
                     </Modal.Body>
                     <Modal.Footer>
                        <Button variant="app-warning" type="submit" className="ps-4 pe-4 add-cat-btn">
                           {editMode ? 'Update Category' : 'Add Category'}
                        </Button>
                     </Modal.Footer>
                  </Form>
               </Modal>
            )
            }
         </Formik >
         <div className="main-div">
            <div className="card category-main me-2 p-md-4">

               {
                  loading ? <LoadingGif /> : ""
               }
               <div className="table-extra-responsive">
                  <table className="table table-striped card-body">
                  <thead>
                     <tr className="category-tr">
                        <th scope="col" className="text-start ps-4">Position</th>
                           <th scope="col" className="text-start ps-4">Category Id</th>
                           <th scope="col" className="text-start ps-4">Category Name</th>

                        <th scope="col" className="text-start ps-4">Icon</th>
                        {/* <th scope="col" className="col-lg-2 cat_btns">Action</th> */}
                     </tr>
                  </thead>
                  <tbody>
                     {
                        categories && categories?.map((data) => (
                           <tr key={data?._id}>
                              <th scope="row" className="text-start ps-4 pt-3">{data?.position}</th>
                              <td className="text-start ps-4 pt-3">{data?._id}</td>
                              <td className="text-start ps-4 pt-3">{data?.category_name}</td>

                              <td className="icon-td text-start ps-4">
                                 <img src={data?.category_icon} alt="categories" />
                              </td>
                              {/* <td className="col-lg-2 d-flex gap-3 cat_btns">
                                 <button className="btn btn-sm edit_btn" onClick={() => onUpdate(data._id)}>
                                    <img src={editIcon} />
                                 </button>
                                 <button className="btn btn-sm delete_btn " onClick={() => handleDeleteConfirmed(data._id)}>
                                    <img src={deleteIcon} />
                                 </button>
                              </td> */}
                           </tr>
                        ))
                     }


                  </tbody>
               </table>
               </div>

            </div>
         </div>

      </MainLayout>
   )
}

export default CategoryPage;